"use client";
import {NeoModal} from "@/components/@modal/neo.modal";
import {Documents} from "@/components/pages/vehicles/documents";
import {DriverDetails} from "@/components/pages/vehicles/driverdetails";
import {VehicleFileUpload} from "@/components/pages/vehicles/file-upload";
import {FileChip} from "@/components/pages/vehicles/FileChip";
import {NeoBreadcrumb, NeoLabel} from "@/components/shared";
import {NeoAGgrid} from "@/components/table/neo-table/neo-ag-grid";
import {useNeoContext} from "@/context/neo/neo.context";
import {CustomerType} from "@/libs/enums/live";
import {decryptUrl} from "@/libs/helper";
import {vehicleService} from "@/service/vehicle.service";
import {Card, CardBody, Spinner} from "@nextui-org/react";
import {Label} from "flowbite-react";
import {useEffect, useRef, useState} from "react";
import toast from "react-hot-toast";

const sKey: string = process.env.NEXT_PUBLIC_NEO_SECRET || "";

interface ManageDriverProps {
  params: PageProps;
}

interface PageProps {
  id: number | string;
  action: string;
  slug: string;
}

interface VehicleProfile {
  name: string;
  regNo: string;
  profileUrl: string;
  driver: string;
  driverUserId: string;
}
export const ViewVehicle: React.FC<ManageDriverProps> = function ({params}) {
  const {filterContext} = useNeoContext();
  const [clientdata, setClient] = useState<Client | null>(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>(null);
  const [vehicleProfile, setVehicleProfile] = useState<VehicleProfile>();
  const [trackerid, setTrackerId] = useState<any>(null);
  const [rcdocuments, setRcDocuments] = useState<any>([]);
  const [insurancedocuments, setInsuranceDocuments] = useState<any>([]);
  const [permitdocuments, setPermitDocuments] = useState<any>([]);
  const [pollutiondocuments, setPollutionDocuments] = useState<any>([]);
  const [licensedocuments, setLicenseDocuments] = useState<any>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [hasActions, sethasActions] = useState(false);
  const [actiontype, setActionType] = useState<any>(null);
  const [modaldata, setModalData] = useState<any>([]);
  const [pendingDeleteId, setPendingDeleteId] = useState<any>([]);
  const [userdetails, setUserDetails] = useState<any>([]);
  const [activeTab, setActiveTab] = useState("vehicle");
  const defualtTabs = [
    {label: "Vehicle Details", id: "vehicle", isVisible: true},
    {label: "Compliance Details", id: "compliance", isVisible: true},
    {label: "Driver Details", id: "driver", isVisible: true},
    {label: "Attendant Details", id: "attendant", isVisible: false},
    {label: "User Details", id: "student", isVisible: true},
    {label: "Documents", id: "documents", isVisible: true}
  ];
  const [tabs, setTab] = useState(defualtTabs);
  const documentTypes = [
    {label: "RC", id: 4},
    {label: "FC", id: 6},
    {label: "Permit", id: 3},
    {label: "Insurance", id: 2},
    {label: "Pollution", id: 5},
    {label: "Road Tax", id: 7},
    {label: "GreenTax", id: 8}
    //{label: "License", id: 1},
    //{label: "Others", id: 0},
  ];
  const rcRef = useRef<any>(null);
  const permitRef = useRef<any>(null);
  const insuranceRef = useRef<any>(null);
  const licenseRef = useRef<any>(null);
  const pollutionRef = useRef<any>(null);
  const refsMap: Record<number, React.RefObject<any>> = {
    1: licenseRef,
    2: insuranceRef,
    3: permitRef,
    4: rcRef,
    5: pollutionRef
  };
  const documentSetterMap: Record<
    string,
    React.Dispatch<React.SetStateAction<any[]>>
  > = {
    regDocuments: setRcDocuments,
    insuranceDocuments: setInsuranceDocuments,
    permitDocuments: setPermitDocuments,
    pollutionDocuments: setPollutionDocuments,
    otherDocuments: setLicenseDocuments
  };
  //0-others, 1-License, 2-Insurance, 3-Permit, 4-RC, 5-Pollution
  const documentTypeKeyMap: Record<number, string> = {
    4: "regDocuments",
    2: "insuranceDocuments",
    3: "permitDocuments",
    5: "pollutionDocuments"
  };
  const tableConfig = {
    columns: [
      {uid: "name", name: "Name", checkbox: false},
      {uid: "admissionNo", name: "Admission No"},
      {uid: "parentName", name: "Parents Name"},
      {uid: "phone", name: "Phone No"},
      {uid: "userClass", name: "Class"}
    ],
    activeColumns: ["name"],
    activeFilters: [],
    style: {
      height: "h-full"
    },
    rowSelection: false,
    meta: {
      id: 0,
      title: "",
      description: "Total Data",
      hasSearch: false,
      hasUpload: false,
      hasDownload: true,
      hasAdd: false,
      hasActions: false,
      hasCheckbox: false,
      hasFilter: false,
      hasFooter: true,
      hasHeader: true,
      hasPagination: true,
      hasCreate: false
    },
    url: {
      page: {},
      api: {}
    },
    actions: [],
    tabledatas: []
  };

  const breadCrumb = [
    {
      link: "/vehicles",
      label: "Vehicles"
    },
    {
      link: "",
      label: `${vehicleProfile?.name}`
    },
    {
      link: "",
      label: "Vehicle Details"
    }
  ];

  useEffect(() => {
    if (filterContext?.client) {
      setClient(filterContext.client);
    }
  }, [filterContext?.client]);
  useEffect(() => {
    const filteredTab = tabs.filter(tab =>
      tab.id === "student"
        ? filterContext.client.customerType !== CustomerType.SME
        : true
    );
    setTab(filteredTab);
  }, []);
  useEffect(() => {
    fetchData();
  }, [params]);

  useEffect(() => {
    if (activeTab == "compliance") {
      const documentType = "";
      fetchDocuments(documentType);
    }
  }, [activeTab]);

  const fetchData = async () => {
    const id = await decryptUrl(params.id as string, sKey);
    setLoading(true);
    setTrackerId(id as string);
    await vehicleService
      .onGetVehicle(id as string)
      .then((response: any) => {
        setData(response);
        onSetVehicleProfile(response);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onSetVehicleProfile = async (response: any) => {
    const vehicleId = await decryptUrl(params.id as string, sKey);

    const result = response?.cards?.find(
      (item: any) => item.type === "vehicle"
    );
    const VehicleName = result?.fields?.find(
      (x: any) => x.key === "name"
    ).value;
    const regNumber = result?.fields?.find((x: any) => x.key === "regNo").value;
    const driverName = result?.fields?.find(
      (x: any) => x.key === "driverName"
    ).value;
    const rawDriverUserId = result?.fields?.find(
      (x: any) => x.key === "driverUserId"
    )?.value;
    const driverUserId =
      rawDriverUserId && !["NA", "N/A"].includes(rawDriverUserId)
        ? rawDriverUserId
        : null;
    setVehicleProfile({
      name: VehicleName,
      regNo: regNumber,
      profileUrl: "",
      driver: driverName,
      driverUserId: driverUserId
    });

    const rcDocuments = getDocumentFieldValue(
      response.cards,
      "registration",
      "regDocuments"
    );
    const insuranceDocuments = getDocumentFieldValue(
      response.cards,
      "insurance",
      "insuranceDocuments"
    );
    const permitDocuments = getDocumentFieldValue(
      response.cards,
      "permit",
      "permitDocuments"
    );
    const pollutionDocuments = getDocumentFieldValue(
      response.cards,
      "pollution",
      "pollutionDocuments"
    );

    setRcDocuments(rcDocuments);
    setInsuranceDocuments(insuranceDocuments);
    setPermitDocuments(permitDocuments);
    setPollutionDocuments(pollutionDocuments);

    const student = response?.cards?.find(
      (item: any) => item.type === "student"
    );
    const tableConfigdatas = {
      ...tableConfig,
      tabledatas: student?.tablerows ?? [],
      otherDatas: {trackerid: vehicleId}
    };
    setUserDetails(tableConfigdatas);
  };

  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleUploadClick = (type: number) => {
    if (fileInputRef.current) {
      fileInputRef.current.setAttribute("data-type", type.toString());
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (type: number, file: File | null) => {
    handleUpload(file, type);
  };

  const handleDrop = (event: any, type: number) => {
    event.preventDefault();
    handleUpload(event.dataTransfer.files, type);
  };

  const handleUpload = (files: any, type: number) => {
    //0-others, 1-License, 2-Insurance, 3-Permit, 4-RC, 5-Pollution
    if (getDocumentLengthByType(type) >= 3) {
      toast.error("Maximum 3 files can be uploaded");
      return;
    }
    if (!files || files.length === 0) {
      return;
    }
    const sourceType: any = 1;
    var documentType: any = type.toString();
    const formData = new FormData();
    formData.append("trackerId", trackerid);
    formData.append("sourceType", sourceType);
    formData.append("documentType", documentType);
    formData.append("name", files.name);
    formData.append(`file[0]`, files);
    /*for (const [key, value] of formData.entries()) {
      console.log(key, value);
    }*/
    submitupload(formData);
  };

  const submitupload = async (formData: FormData) => {
    const additionalPrimaryData = {
      insId: clientdata?.institutionId,
      currentUser: clientdata?.institutionUserId
    };
    const documentType = formData.get("documentType");
    try {
      const response = await vehicleService.ondocumentuploads(
        additionalPrimaryData,
        formData
      );
      if (response?.data?.status === "success") {
        toast.success(response?.data?.message);
        await fetchDocuments(documentType);
      } else if (response?.data?.errors?.length === 0) {
        toast.error(response?.data?.message);
      }
    } catch (err: any) {
      if (err?.errors?.length > 0) {
        err.errors.forEach(
          ({field, message}: {field: any; message: string}) => {
            toast.error(message);
          }
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const removeUploadfile = (id: number, documentType: number) => {
    var removedata = {
      id: id,
      documentType: documentType
    };
    setPendingDeleteId(removedata);
    setModalOpen(true);
    sethasActions(true);
    setActionType("delete");
  };

  const handleremoveConfirm = async () => {
    if (pendingDeleteId?.id) {
      const documentid: any = {id: pendingDeleteId.id};
      try {
        const response = await vehicleService.onremovedocuments(documentid);
        if (response?.data?.status === "success") {
          setModalOpen(false);
          sethasActions(false);
          setActionType(null);
          setModalData(null);
          toast.success(response?.data?.message);
          fetchDocuments(pendingDeleteId.documentType);
          setPendingDeleteId(null);
        } else if (response?.data?.errors?.length === 0) {
          toast.error(response?.data?.message);
        }
      } catch (err: any) {
        if (err?.errors?.length > 0) {
          err.errors.forEach(
            ({field, message}: {field: any; message: string}) => {
              toast.error(message);
            }
          );
        }
      } finally {
        setLoading(false);
        setPendingDeleteId(null);
      }
    } else if (pendingDeleteId?.driverId) {
      const requestdata: any = {
        userId: pendingDeleteId?.driverId,
        trackerId: trackerid,
        assign: pendingDeleteId?.assign
      };
      updateDriverAssignment(requestdata);
    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
    sethasActions(false);
    setActionType(null);
    setPendingDeleteId(null);
    setModalData(null);
  };

  const uploadfield = (type: number) => {
    const docList: any = getDocumentLengthByType(type);
    const inputRef = refsMap[type];
    if (docList >= 3) {
      toast.error("Maximum 3 files can be uploaded");
      return;
    }
    inputRef?.current?.trigger();
  };

  const fetchDocuments = async (documentType?: any) => {
    const sourceType: any = 1;
    let requestdata: any = {};
    if (documentType) {
      requestdata = {
        sourceType: sourceType,
        trackerId: trackerid,
        documentType: documentType
      };
    } else {
      requestdata = {
        sourceType: sourceType,
        trackerId: trackerid
      };
    }
    try {
      const response = await vehicleService.ondocumentsread(requestdata);
      if (response?.data?.status === "success") {
        const documentdatas = response?.data?.data;
        if (documentdatas) {
          if (documentType) {
            const documentTypeKey = documentTypeKeyMap[documentType];
            const setter = documentSetterMap[documentTypeKey];
            if (
              setter &&
              documentdatas &&
              Array.isArray(documentdatas[documentTypeKey])
            ) {
              setter(documentdatas[documentTypeKey]);
            }
          } else {
            Object.entries(documentSetterMap).forEach(([key, setter]) => {
              const list = documentdatas?.[key];
              if (Array.isArray(list)) {
                setter(list);
              }
            });
          }
        }
      } else if (response?.data?.errors?.length === 0) {
        toast.error(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (err: any) {
      if (err?.errors?.length > 0) {
        err.errors.forEach(
          ({field, message}: {field: any; message: string}) => {
            toast.error(message);
          }
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const getDocumentLengthByType = (type: number): number => {
    const docMap: Record<number, any[]> = {
      1: licensedocuments,
      2: insurancedocuments,
      3: permitdocuments,
      4: rcdocuments,
      5: pollutiondocuments
    };
    return docMap[type]?.length || 0;
  };

  const modaldriverForm = async () => {
    const driverdetails = await fetchDerivelists();
    if (driverdetails.length > 0) {
      const modaldatas: any = {
        driverdetails: driverdetails
      };
      setActionType("assigndriver");
      sethasActions(false);
      setModalData(modaldatas);
      setModalOpen(true);
    }
  };

  const fetchDerivelists = async () => {
    try {
      const loginuserid = clientdata?.institutionUserId;
      const response = await vehicleService.onDriverlists(loginuserid);
      if (response?.data?.status === "success") {
        const driverdatas = response?.data?.data?.driverData;
        if (driverdatas) {
          const driverDatas = driverdatas.map((driver: any) => ({
            name: driver.name,
            avatar: driver.driverPhoto || "/icons/user.svg",
            userid: driver.userId
          }));
          return driverDatas;
        } else {
          toast.error(response?.data?.message);
          return [];
        }
      } else if (response?.data?.errors?.length === 0) {
        toast.error(response?.data?.message);
        return [];
      }
    } catch (err: any) {
      if (err?.errors?.length > 0) {
        err.errors.forEach(
          ({field, message}: {field: any; message: string}) => {
            toast.error(message);
          }
        );
      }
      return [];
    }
  };

  const assignDriverToVehicle = async (data: any) => {
    if (data?.driverId) {
      const requestdata: any = {
        userId: data?.driverId,
        trackerId: trackerid,
        assign: data?.assign
      };
      updateDriverAssignment(requestdata);
    }
  };

  const unassignDriverToVehicle = async (data: any) => {
    setPendingDeleteId(data);
    setActionType("delete");
    setModalOpen(true);
    sethasActions(true);
  };

  const updateDriverAssignment = async (requestdata: any) => {
    try {
      let driverId: any = "";
      if (requestdata?.assign) {
        driverId = requestdata?.userId;
      }

      const response =
        await vehicleService.onUpdateDriverAssignment(requestdata);
      if (response?.data?.status === "success") {
        setVehicleProfile(prev => {
          if (!prev) return prev;
          return {
            ...prev,
            driverUserId: driverId
          };
        });
        sethasActions(false);
        setActionType(null);
        setModalData(null);
        setPendingDeleteId(null);
        setModalOpen(false);
        toast.success(response?.data?.message);
        //setDriverDetailsKey(prev => prev + 1);
      } else if (response?.data?.errors?.length === 0) {
        toast.error(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (err: any) {
      if (err?.errors?.length > 0) {
        err.errors.forEach(
          ({field, message}: {field: any; message: string}) => {
            toast.error(message);
          }
        );
      }
    } finally {
      setLoading(false);
      setPendingDeleteId(null);
    }
  };

  const getDocumentFieldValue = (
    cards: any[],
    sectionType: string,
    fieldKey: string
  ) => {
    return (
      cards
        ?.find(item => item.type === sectionType)
        ?.fields?.find((field: any) => field.key === fieldKey)?.value || []
    );
  };

  const modalActionMap: Record<string, (submitdata?: any) => Promise<void>> = {
    delete: () => handleremoveConfirm(),
    assigndriver: submitdata => assignDriverToVehicle(submitdata)
  };

  return (
    <>
      {loading ? (
        <Spinner color="default" />
      ) : (
        <div className="flex min-h-[calc(100vh-63px)] w-full flex-col p-5">
          {/* <div className="mb-5 flex-row">
            <NeoHeader message="Vehicle"></NeoHeader>
          </div> */}
          <div className="mb-2 flex-row">
            <NeoBreadcrumb menus={breadCrumb}></NeoBreadcrumb>
          </div>
          <div className="w-full flex-row">
            <div className="flex flex-wrap gap-2 bg-transparent py-2">
              {tabs
                .filter(tab => tab.isVisible)
                .map(tab => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`rounded-full border px-4 py-2 text-sm transition-all duration-150
                    ${
                      activeTab === tab.id
                        ? "border-black bg-black text-white"
                        : "border-gray-400 bg-transparent text-gray-400 hover:text-black"
                    }`}
                    title={tab.label}
                  >
                    {tab.label}
                  </button>
                ))}
            </div>
            <div className="mt-1">
              {activeTab === "vehicle" && (
                <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
                  {data?.cards
                    ?.filter((card: any) => card.type === "vehicle")
                    .map((item: any, cardIndex: number) => (
                      <Card key={cardIndex} className="mb-2">
                        <CardBody>
                          <Label
                            className="-mt-2 block p-2 text-xl font-bold"
                            value={item.title}
                          />

                          {/*item?.type === "vehicle" && (
                            <div className="-mt-2 w-full p-2">
                              <div className="flex w-full items-center justify-between rounded-md bg-gray-100 px-5 py-3">
                                <div className="flex items-center gap-2">
                                  <div>
                                    <Label
                                      className="block text-xl font-bold"
                                      value={vehicleProfile?.name}
                                    />
                                    <Label
                                      className="text-lg text-gray-500"
                                      value={
                                        vehicleProfile?.regNo &&
                                        vehicleProfile?.driver
                                          ? `${vehicleProfile.regNo} | ${vehicleProfile.driver}`
                                          : "NA"
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )*/}

                          <div className="flex-row px-3">
                            <div className="flex flex-wrap">
                              {item.fields.map(
                                (field: any, fieldIndex: number) =>
                                  field?.isVisible ? (
                                    <div
                                      className="mb-5 w-1/2"
                                      key={fieldIndex}
                                    >
                                      <NeoLabel
                                        label={field.label}
                                        value={field.value}
                                      />
                                    </div>
                                  ) : null
                              )}
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    ))}

                  {data?.cards
                    ?.filter((card: any) => card.type === "specifications")
                    .map((item: any, cardIndex: number) => (
                      <Card key={cardIndex} className="mb-2">
                        <CardBody>
                          <Label
                            className="-mt-2 block p-2 text-xl font-bold"
                            value={item.title}
                          />
                          <div className="flex-row px-3">
                            <div className="flex flex-wrap">
                              {item.fields.map(
                                (field: any, fieldIndex: number) =>
                                  field?.isVisible ? (
                                    <div
                                      className="mb-5 w-1/2"
                                      key={fieldIndex}
                                    >
                                      <NeoLabel
                                        label={field.label}
                                        value={field.value}
                                      />
                                    </div>
                                  ) : null
                              )}
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    ))}
                </div>
              )}
              {activeTab === "compliance" && (
                <>
                  <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
                    {data?.cards
                      ?.filter((card: any) => card.type === "registration")
                      .map((item: any, cardIndex: number) => (
                        <Card key={cardIndex} className="mb-2">
                          <CardBody>
                            <Label
                              className="-mt-2 block p-2 text-xl font-bold"
                              value={item.title}
                            />
                            <div className="flex-row px-3">
                              <div className="flex flex-wrap">
                                {item.fields.map(
                                  (field: any, fieldIndex: number) =>
                                    field?.isVisible ? (
                                      <div
                                        className="mb-5 w-1/2"
                                        key={fieldIndex}
                                      >
                                        <NeoLabel
                                          label={field.label}
                                          value={field.value}
                                        />
                                      </div>
                                    ) : null
                                )}

                                <VehicleFileUpload
                                  type={4}
                                  onChange={handleFileChange}
                                  ref={rcRef}
                                  className={
                                    rcdocuments?.length > 0 ? "hidden" : "block"
                                  }
                                />
                              </div>
                              {rcdocuments?.length > 0 && (
                                <div className="flex flex-col gap-2">
                                  <div className="flex flex-nowrap gap-2 overflow-auto">
                                    {rcdocuments.map(
                                      (fileItem: any, index: number) => (
                                        <FileChip
                                          key={fileItem.id}
                                          file={fileItem}
                                          onRemove={() =>
                                            removeUploadfile(fileItem.id, 4)
                                          }
                                        />
                                      )
                                    )}
                                  </div>
                                  <div>
                                    <button
                                      className="text-sm font-medium text-[#349C42]"
                                      onClick={() => uploadfield(4)}
                                    >
                                      Add More Files
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </CardBody>
                        </Card>
                      ))}

                    {data?.cards
                      ?.filter((card: any) => card.type === "insurance")
                      .map((item: any, cardIndex: number) => (
                        <Card key={cardIndex} className="mb-2">
                          <CardBody>
                            <Label
                              className="-mt-2 block p-2 text-xl font-bold"
                              value={item.title}
                            />
                            <div className="flex-row px-3">
                              <div className="flex flex-wrap">
                                {item.fields.map(
                                  (field: any, fieldIndex: number) =>
                                    field?.isVisible ? (
                                      <div
                                        className="mb-5 w-1/2"
                                        key={fieldIndex}
                                      >
                                        <NeoLabel
                                          label={field.label}
                                          value={field.value}
                                        />
                                      </div>
                                    ) : null
                                )}
                                <VehicleFileUpload
                                  type={2}
                                  onChange={handleFileChange}
                                  ref={insuranceRef}
                                  className={
                                    insurancedocuments?.length > 0
                                      ? "hidden"
                                      : "block"
                                  }
                                />
                              </div>
                              {insurancedocuments?.length > 0 && (
                                <div className="flex flex-col gap-2">
                                  <div className="flex flex-nowrap gap-2 overflow-auto">
                                    {insurancedocuments.map(
                                      (fileItem: any, index: number) => (
                                        <FileChip
                                          key={fileItem.id}
                                          file={fileItem}
                                          onRemove={() =>
                                            removeUploadfile(fileItem.id, 2)
                                          }
                                        />
                                      )
                                    )}
                                  </div>
                                  <div>
                                    <button
                                      className="text-sm font-medium text-[#349C42]"
                                      onClick={() => uploadfield(2)}
                                    >
                                      Add More Files
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </CardBody>
                        </Card>
                      ))}
                  </div>
                  <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
                    {data?.cards
                      ?.filter((card: any) => card.type === "permit")
                      .map((item: any, cardIndex: number) => (
                        <Card key={cardIndex} className="mb-2">
                          <CardBody>
                            <Label
                              className="-mt-2 block p-2 text-xl font-bold"
                              value={item.title}
                            />
                            <div className="flex-row px-3">
                              <div className="flex flex-wrap">
                                {item.fields.map(
                                  (field: any, fieldIndex: number) =>
                                    field?.isVisible ? (
                                      <div
                                        className="mb-5 w-1/2"
                                        key={fieldIndex}
                                      >
                                        <NeoLabel
                                          label={field.label}
                                          value={field.value}
                                        />
                                      </div>
                                    ) : null
                                )}
                                <VehicleFileUpload
                                  type={3}
                                  onChange={handleFileChange}
                                  ref={permitRef}
                                  className={
                                    permitdocuments?.length > 0
                                      ? "hidden"
                                      : "block"
                                  }
                                />
                              </div>
                              {permitdocuments?.length > 0 && (
                                <div className="flex flex-col gap-2">
                                  <div className="flex flex-nowrap gap-2 overflow-auto">
                                    {permitdocuments.map(
                                      (fileItem: any, index: number) => (
                                        <FileChip
                                          key={fileItem.id}
                                          file={fileItem}
                                          onRemove={() =>
                                            removeUploadfile(fileItem.id, 3)
                                          }
                                        />
                                      )
                                    )}
                                  </div>
                                  <div>
                                    <button
                                      className="text-sm font-medium text-[#349C42]"
                                      onClick={() => uploadfield(3)}
                                    >
                                      Add More Files
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </CardBody>
                        </Card>
                      ))}
                    {data?.cards
                      ?.filter((card: any) => card.type === "pollution")
                      .map((item: any, cardIndex: number) => (
                        <Card key={cardIndex} className="mb-2">
                          <CardBody>
                            <Label
                              className="-mt-2 block p-2 text-xl font-bold"
                              value={item.title}
                            />
                            <div className="flex-row px-3">
                              <div className="flex flex-wrap">
                                {item.fields.map(
                                  (field: any, fieldIndex: number) =>
                                    field?.isVisible ? (
                                      <div
                                        className="mb-5 w-1/2"
                                        key={fieldIndex}
                                      >
                                        <NeoLabel
                                          label={field.label}
                                          value={field.value}
                                        />
                                      </div>
                                    ) : null
                                )}
                                <VehicleFileUpload
                                  type={5}
                                  onChange={handleFileChange}
                                  ref={pollutionRef}
                                  className={
                                    pollutiondocuments?.length > 0
                                      ? "hidden"
                                      : "block"
                                  }
                                />
                              </div>
                              {pollutiondocuments?.length > 0 && (
                                <div className="flex flex-col gap-2">
                                  <div className="flex flex-nowrap gap-2 overflow-auto">
                                    {pollutiondocuments.map(
                                      (fileItem: any, index: number) => (
                                        <FileChip
                                          key={fileItem.id}
                                          file={fileItem}
                                          onRemove={() =>
                                            removeUploadfile(fileItem.id, 5)
                                          }
                                        />
                                      )
                                    )}
                                  </div>
                                  <div>
                                    <button
                                      className="text-sm font-medium text-[#349C42]"
                                      onClick={() => uploadfield(5)}
                                    >
                                      Add More Files
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </CardBody>
                        </Card>
                      ))}
                  </div>
                </>
              )}
              {activeTab === "driver" && (
                <>
                  {vehicleProfile?.driverUserId ? (
                    <DriverDetails
                      driveId={vehicleProfile?.driverUserId}
                      onRemove={unassignDriverToVehicle}
                    />
                  ) : (
                    <>
                      <div className="flex min-h-[400px] flex-col items-center justify-start bg-white px-4 pt-16">
                        <img
                          src="/images/users.svg"
                          alt="No driver"
                          className="mb-6 h-32 w-32 opacity-80"
                        />
                        <p className="mb-4 text-center font-bold">
                          No driver assigned
                        </p>
                        <button
                          className="rounded-md bg-yellow-400 px-6 py-2 font-semibold text-black transition hover:bg-yellow-500"
                          onClick={() => modaldriverForm()}
                        >
                          Assign Driver
                        </button>
                      </div>
                    </>
                  )}
                </>
              )}
              {activeTab === "attendant" && (
                <Card>
                  <CardBody>
                    <div className="w-full p-3">Attendant Details Content</div>
                  </CardBody>
                </Card>
              )}
              {activeTab === "student" &&
                data?.cards
                  ?.filter((card: any) => card.type === "student")
                  .map((item: any, cardIndex: number) => (
                    <Card key={cardIndex} className="mb-2">
                      <CardBody>
                        <Label
                          className="-mt-2 block p-2 text-xl font-bold"
                          value={item.title}
                        />
                        {/*<ViewTable tabledatas={item}/>*/}
                        <NeoAGgrid table={userdetails} />
                      </CardBody>
                    </Card>
                  ))}
              {activeTab === "documents" && (
                <Documents
                  datas={{
                    documentTypes: documentTypes,
                    trackerId: trackerid,
                    clientdata: clientdata
                  }}
                  onRemove={(category, index) => {
                    removeUploadfile(Number(category), index);
                  }}
                />
              )}
            </div>
          </div>
        </div>
      )}
      <NeoModal
        onOpen={modalOpen}
        onClose={handleModalClose}
        actionType={actiontype}
        onModalSubmit={modalActionMap[actiontype ?? ""]}
        hasActions={hasActions}
        data={modaldata}
      />
    </>
  );
};
